import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, connect } from "react-redux";

import classes from "./EnableDisableSection.css";
import ToggleSwitch from "../../../UI/ToggleSwitch/ToggleSwitch";
import EnableDisableSection from "./EnableDisableSection";
import Basics from "../EnableDisable/basics/Basics";
import Description from "./Description/Description";
import CallerDetails from "./CallerDetails/CallerDetails";
import ImpactedMember from "./ImpectedMember/ImpactedMember";
import Reporter from "../EnableDisable/reporter/Reporter";
import * as actions from "../../../store/actions";
import {
  BASE_ACCOUNT_SECURITY_ERROR_MESSAGE,
  DISABLE_REASONS,
  DISABLE_SUCCESS,
  OTHER_REASON,
  SESSION_SUPERUSER,
  USER_ENABLED_BY_ADMIN,
  INCIDENT_FORM_ENABLED,
  reasonComponents,
  REPORTER_INCIDENT,
  BASICS_INCIDENT,
  DESCRIPTION_INCIDENT,
  CALLER_DETAILS_INCIDENT,
  IMPACTED_MEMBER_INCIDENT,
  SESSION_BASELINEAGENT,
  BASE_LINE_AGENTS_RESTRICT_DISABLE,
  DISABLE_BASE_ACCOUNT,
  HSID_BASE,
} from "../../../shared/Constants";
import {
  isBasicMemberAccount,
  isAccountDisabled,
  isAccountEnabled,
  isAccountUpdateRequired,
} from "../../../shared/utility";
import Message from "../../../components/Message/Message";
import Button from "../../../UI/Button/Button";

const AccounSecurity = (props) => {
  const toggleState = useSelector(
    (state) => state.member.accountSecurityToggle
  );
  const [disableSuccessMessage, setDisableSuccessMessage] = useState("");

  const [targetPortal, setTargetPortal] = useState("");
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [incidentTicket, setIncidentTicket] = useState("");
  const [buttonState, setButtonState] = useState(false);
  const [description, setDescription] = useState("");
  const [reporterDetails, setReporterDetails] = useState({});
  const [callerDetails, setCallerDetails] = useState({});
  const [basicDetails, setBasicDetails] = useState({});
  const [reporterFormValid, setReporterFormValid] = useState(false);
  const [basicFormValid, setBasicFormValid] = useState(false);
  const [descriptionValid, setDescriptionValid] = useState(false);
  const [callerDetailsValid, setCallerDetailsValid] = useState(false);
  const [enableDisableValid, setEnableDisableValid] = useState(false);

  const dispatch = useDispatch();
  const enableDisableStatusMsg = useSelector(
    (state) => state.member.enableDisableStatusMsg
  );
  const memberEsso = useSelector((state) => state.member.member.essoData);

  useEffect(() => {
    var message = localStorage.getItem(DISABLE_SUCCESS);
    setDisableSuccessMessage(message);
    isSaveButtonDisabled();
    if (props.disabledMember)
      localStorage.removeItem(DISABLE_SUCCESS);
  }, [
    props.disabledMember,
    targetPortal,
    reason,
    incidentTicket
  ]);

  useEffect(() => {
    return () => {
      dispatch(actions.setToggleState(false));
    };
  }, []);

  useEffect(() => {
    dispatch(actions.setToggleState(false));
  }, [props.agentDetails?.userType]);

  const toggleEnaDisaModal = () => {
    setReason("");
    setTargetPortal("");
    setIncidentTicket("");
    dispatch(actions.setToggleState(!toggleState));
  };

  const createRequest = (
    incTicket,
    info,
    reason,
    portalShortNm,
    rsnTypCd,
    portalVersion
  ) => {
    if (!reasonComponents[reason] || !INCIDENT_FORM_ENABLED) {
      return {
        hsid: memberEsso.uuid,
        userid: memberEsso.userName,
        info: info ? info : (props.idType === HSID_BASE?DISABLE_BASE_ACCOUNT:reason),
        incidentTicket: incTicket,
        portalShortName: portalShortNm,
        reasonTypeCode: rsnTypCd,
        portalVersion: portalVersion,
        isBaseAgentPortal: props.idType === HSID_BASE
      };
    }
    let userData = {
      healthSafeId: memberEsso.uuid,
      empMsId: props.agentDetails.userLoginId,
      createdBy: props.agentDetails.userLoginId,
      reason: reason,
      incidentNumber: props.impactedMemberData ? props.impactedMemberData.incidentNumber: incTicket,
      portalShortName: props.impactedMemberData ? props.impactedMemberData.prtlShrtNm: portalShortNm,
      reasonTypeCode:props.impactedMemberData ? props.impactedMemberData.reasonTypeCode: rsnTypCd,
      newAPI: true,
    };
    if (incidentComponentDisplay(REPORTER_INCIDENT)) {
      const reportersDateTime = props.impactedMemberData ? props.impactedMemberData.reporterTs
      : new Date(
        `${reporterDetails.date.value}T${reporterDetails.time.value}Z`
      );
      userData = {
        ...userData,
        ...{
          reporterEmail: props.agentDetails.agentEmailId,
          reporterTs: reportersDateTime,
          reporterTimeZone: props.impactedMemberData ? props.impactedMemberData.reporterTimeZone: reporterDetails.timeZone.value,
        },
      };
    }
    if (incidentComponentDisplay(BASICS_INCIDENT)) {
      const basicsDateTime = props.impactedMemberData ? props.impactedMemberData.issueOccurredTs
      :new Date(
        `${basicDetails.date.value}T${basicDetails.time.value}Z`
      );
      userData = {
        ...userData,
        ...{
          issueOccurredTs: basicsDateTime,
          issueOccurredTimeZone:props.impactedMemberData ? props.impactedMemberData.issueOccurredTimeZone: basicDetails.timeZone.value,
        },
      };
    }
    if (incidentComponentDisplay(CALLER_DETAILS_INCIDENT)) {
      userData = {
        ...userData,
        ...{
          callerFirstName: props.impactedMemberData ? props.impactedMemberData.callerFirstName:callerDetails.firstName.value,
          callerLastName: props.impactedMemberData ? props.impactedMemberData.callerLastName:callerDetails.lastName.value,
          callerPhone: props.impactedMemberData ? props.impactedMemberData.callerPhone:callerDetails.phone.value,
          callerEmail: props.impactedMemberData ? props.impactedMemberData.callerEmail:callerDetails.email.value,
        },
      };
    }
    if (incidentComponentDisplay(IMPACTED_MEMBER_INCIDENT)) {
      let impactedMemberList = [];

      for (let impactedMember in props.incidentMembersList) {
        if (props.incidentMembersList[impactedMember]?.essoData?.essoStatus?.enableDisableStatus === "enabled") {
          impactedMemberList.push({
            healthSafeId:
              props.incidentMembersList[impactedMember].member[0].healthSafeId,
            memberType:
              props.incidentMembersList[
                impactedMember
              ].priImpactedFlag.toUpperCase(),
            username: props.incidentMembersList[impactedMember].essoData.userName,
            actionRequested: "DISABLE",
            createdBy: props.agentDetails.userLoginId,
          });
        }
      }
      userData = {
        ...userData,
        incidentMemberActionRequests: impactedMemberList,
      };
    }

    if (incidentComponentDisplay(DESCRIPTION_INCIDENT)) {
      userData = { ...userData, issueDescription: props.impactedMemberData ? props.impactedMemberData.issueDescription : description };
    }

    return userData;
  };

  const enaDisableSubmitHandler = (
    incTicket,
    info,
    resn,
    portalShortNm,
    rsnTypCd,
    portalVersion
  ) => {
    dispatch(actions.enableDisableStart());
    if (isAccountUpdateRequired(props.incidentMembersList) && INCIDENT_FORM_ENABLED) {
      let userData = createRequest(
        incTicket,
        info,
        reason,
        portalShortNm,
        rsnTypCd,
        portalVersion
      );
      dispatch(
        actions.updateIncident(
          userData
        )
      );
    } 
    else {
      let userData = createRequest(
        incTicket,
        info,
        resn,
        portalShortNm,
        rsnTypCd,
        portalVersion
      );
      dispatch(
        actions.enableDisableAccount(
          userData,
          memberEsso.essoStatus.enableDisableStatus
        )
      );
    }
  };

  const formSubmitHandler = (event) => {
    if(props.idType !== HSID_BASE){
      event.preventDefault();
    }
    const disableReasons = JSON.parse(localStorage.getItem(DISABLE_REASONS));
    let newNote = null;
    if (note && isAccountEnabled(memberEsso) && reason !== OTHER_REASON) {
      newNote = reason + " : " + note;
    }
    const selectedReason = disableReasons?.filter(
      (reson) => reson.reason === reason
    );
    const updateAction = isAccountUpdateRequired(props.incidentMembersList);
    if (isAccountEnabled(memberEsso) || updateAction) {
      enaDisableSubmitHandler(
        incidentTicket,
        newNote,
        reason,
        targetPortal,
        selectedReason?.[0]?.reasonTypeCode,
        "1.0"
      );
    } else if (props.disabledMember !== null) {
      enaDisableSubmitHandler(incidentTicket, note, USER_ENABLED_BY_ADMIN);
    }
    toggleEnaDisaModal();
  };

  let message =
    enableDisableStatusMsg && enableDisableStatusMsg.type === "Error" ? (
      <Message msgType="Error" info={enableDisableStatusMsg.info} />
    ) : null;
  if (disableSuccessMessage && props.agentDetails.userType !== SESSION_BASELINEAGENT) {
    message = (
      <span>
        {" "}
        <label style={{ backgroundColor: "yellow", margin: "10px" }}>
          {" "}
          {disableSuccessMessage}{" "}
        </label>
      </span>
    );
  } else if (props.agentDetails.userType === SESSION_BASELINEAGENT && isAccountDisabled(memberEsso)) {
    message = (
      <span className={classes.ErrorText}>
        {BASE_LINE_AGENTS_RESTRICT_DISABLE}
      </span>
    );
  }
  const basicMemberAccount = isBasicMemberAccount(props.idType) 
  && props.agentDetails.userType !== SESSION_BASELINEAGENT;

  const incidentComponentDisplay = (componentDetails) => {
    return reasonComponents[reason]?.includes(componentDetails);
  };

  const isSaveButtonDisabled = () => {
    if (props.disabledMember && incidentTicket) {
      setEnableDisableValid(true);
    } else if (incidentTicket === "") {
      setEnableDisableValid(false);
    } else if (reason === "") {
      setEnableDisableValid(false);
    } else if (targetPortal === "") {
      setEnableDisableValid(false);
    } else if (incidentTicket !== "" && reason !== "" && targetPortal !== "") {
      setEnableDisableValid(true);
    }
  };

  

  const displayIncidentFormFields = () => {
    return INCIDENT_FORM_ENABLED;
  };

  let buttons = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        margin: "10px 60px 10px 0",
      }}
    >
      <Button
        id="cancel"
        btnType="Cancel"
        clicked={toggleEnaDisaModal}
        attr={{ type: "button" }}
      >
        Cancel
      </Button>
      <Button id="save" btnType="Search" disabled={INCIDENT_FORM_ENABLED ? isSaveButtonDisabled() : !enableDisableValid}>
        Submit
      </Button>
    </div>
  );

  let isAccountSecurityDisabled = (props.userType !== SESSION_SUPERUSER && isAccountDisabled(memberEsso)) || props.idType===HSID_BASE;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div>
          <h2 className={classes.EnableDisableTitle}>Account Security</h2>
        </div>
      </div>
      <ToggleSwitch
        id="esso"
        labelText="Account Enable/Disable"
        status={isAccountEnabled(memberEsso) ? true : false}
        onText="Enabled"
        offText="Disabled"
        disabled={isAccountSecurityDisabled}
        clicked={props.idType === HSID_BASE && isAccountEnabled(memberEsso)?formSubmitHandler:toggleEnaDisaModal}
      />
      {message}
      {toggleState && (
        <>
          <form onSubmit={formSubmitHandler}>
            {((props.idType === HSID_BASE && isAccountDisabled(memberEsso)) || (props.idType !== HSID_BASE)) && <EnableDisableSection
              modalTitle="Account Disable/Enable"
              modalText="Please enter an Incident Ticket # and reason for the account disable or enable."
              isValid = {setEnableDisableValid}
              setNote={setNote}
              setReason={setReason}
              setIncidentTicket={setIncidentTicket}
              setTargetPortal={setTargetPortal}
              userType={props.userType}
            />}
            {displayIncidentFormFields() ? (
              <>
                {incidentComponentDisplay(REPORTER_INCIDENT) && (
                  <Reporter
                    isValid={setReporterFormValid}
                    setReporterDetails={setReporterDetails}
                  />
                )}
                {incidentComponentDisplay(BASICS_INCIDENT) && (
                  <Basics
                    isValid = {setBasicFormValid}
                    setBasicDetails={setBasicDetails}
                  />
                )}
                {incidentComponentDisplay(DESCRIPTION_INCIDENT) && (
                  <Description
                    isValid = {setDescriptionValid}
                    setDescription={setDescription}
                  />
                )}
                {incidentComponentDisplay(CALLER_DETAILS_INCIDENT) && (
                  <CallerDetails
                    isValid = {setCallerDetailsValid}
                    setCallerDetails={setCallerDetails}
                  />
                )}
                {incidentComponentDisplay(IMPACTED_MEMBER_INCIDENT) && (
                  <ImpactedMember setButtonState={isSaveButtonDisabled} userType={props.userType}/>
                )}
              </>
            ) : null}
            {buttons}
          </form>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    incidentMembersList: state.member.incidentMembersList,
    impactedMemberData: state.member.impactedMemberData,
    enableDisableStatusMsg: state.member.enableDisableStatusMsg,
    agentDetails: state.usr.user,
    disabledMember: state.member.disabledMember
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccounSecurity);